import Index from 'modules/help';

export default Index;
